export default __webpack_public_path__ + "static/media/s2.350d7ab2.jpg";